import { Backbone } from "extensions/backbone";
import moment from "moment";

import { Filter } from "./filter";

export const Filters = Backbone.Collection.extend({
    url: "/merchant/:merchant_ref/user/filters",
    model: Filter,
    comparator: (m) => -moment.utc(m.get("modified")),
    
    getRecent() {
        return (this.first(10) || []).map((m) => ({
            id: m.id,
            name: m.get("name")
        }));
    }
});
